import { merge } from 'lodash'
import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

type State = {
  limit: number
  scroll: number
  progress: number
  direction: number
  velocity: number
  complete?: boolean
  halfway?: boolean
}

type Actions = {
  // eslint-disable-next-line no-unused-vars
  setState: (state?: Partial<State>) => void
  resetState: () => void
}

const initialState: State = {
  limit: 0,
  scroll: 0,
  progress: 0,
  direction: 0,
  velocity: 0,
  complete: false,
  halfway: false
}

const useLenisStore = create(
  subscribeWithSelector(
    immer<State & Actions>((set, get) => ({
      ...initialState,
      setState: (state) => set((prevState) => merge(prevState, state)),
      resetState: () => get().setState(initialState)
    }))
  )
)

export { useLenisStore }
